<template>
  <textarea
    :value="value"
    @input="onInput"
    :rows="rows"
    ref="textarea"
    class="outline-0 focus:outline-0 min-h-5"
    style="resize: none"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @keydown="$emit('keydown', $event)"
    @keyup="$emit('keyup')"
  ></textarea>
</template>

<script>
  export default {
    name: 't-textarea',
    props: {
      value: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 100
      }
    },
    data() {
      return {
        rows: 1
      }
    },
    methods: {
      autoResize() {
        const textarea = this.$refs.textarea
        textarea.style.height = 'auto'
        textarea.style.height = `${textarea.scrollHeight || this.height}px`
      },
      onInput(event) {
        this.$emit('input', event.target.value)
        this.autoResize()
      }
    },
    watch: {
      value() {
        this.autoResize()
      }
    },
    mounted() {
      this.autoResize()
    }
  }
</script>
